import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authorizeAdmin } from 'api/admin/userPermissions/authorizeAdmin'
import { userPermissionsKeys } from './keys'

export function useAuthorizeAdminMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: authorizeAdmin,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: userPermissionsKeys.all,
      })
    },
  })
}
